/* global google */
import React, { Component } from "react";
import { compose } from "recompose";
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs
} from "react-google-maps";
import { prm } from "../../../mocks";

//const FLOOR1 = require("../assets/floor1.png");
//const FLOOR0 = require("../assets/floor0.png");

class GoogleMapView extends Component {
  state = {
    isMarkerShown: false,
    floor: true
  };

  render() {
    const { onPinClick, onMapClick } = this.props;

    const MapWithGroundOverlay = compose(
      withScriptjs,
      withGoogleMap
    )(props => (
      <GoogleMap
        defaultZoom={17}
        defaultCenter={{ lat: 40.877, lng: 14.282828 }}
        google={google}
        onClick={() => onMapClick()}
      >
        {/*<GroundOverlay*/}
        {/*  //defaultUrl="https://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg"*/}
        {/*  defaultUrl={this.state.floor ? FLOOR0 : FLOOR1}*/}
        {/*  defaultBounds={new google.maps.LatLngBounds(*/}
        {/*    new google.maps.LatLng(40.876844, 14.280780), //SW*/}
        {/*    new google.maps.LatLng(40.879434, 14.284194)  //NE*/}
        {/*  )}*/}
        {/*  defaultOpacity={1}*/}
        {/*/>*/}
        {prm.map(item => (
          <Marker
            position={{ lat: item.lat, lng: item.lng }}
            onClick={() => onPinClick(item)}
          />
        ))}
      </GoogleMap>
    ));

    return (
      <div style={styles.container}>
        <MapWithGroundOverlay
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBAIxUNGqQL7EM1GjRxsYNCshrawvHw4fc&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100vh` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
        {/*<button*/}
        {/*  onClick={() => this.setState({floor: !this.state.floor})}*/}
        {/*  style={{position: 'absolute', bottom: "5%", left: "21%", width: 200, height: 100, fontSize: 20, borderRadius: 10}}*/}
        {/*>Cambia piano {this.state.floor ? "(0)" : "(1)"}</button>*/}
      </div>
    );
  }
}

const styles = {
  container: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1
  },
  iconRoot: {
    textAlign: "center"
  },
  imageIcon: {
    height: "100%"
  }
};

export default GoogleMapView;
